var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.82 2.66797C22.1587 2.66797 26.4866 6.99588 26.4866 12.3346C26.4866 15.1294 25.2858 17.6942 22.9359 19.9905C22.8333 20.0908 22.7539 20.2115 22.7024 20.3442L22.6605 20.4806L21.1524 27.0081C20.8554 28.2933 19.7579 29.2245 18.4603 29.3239L18.2294 29.3328H15.411C14.0916 29.3328 12.9372 28.4727 12.5484 27.2304L12.4878 27.0074L10.9817 20.481C10.9387 20.2945 10.843 20.1242 10.7061 19.9904C8.46686 17.8035 7.27036 15.373 7.16149 12.7323L7.15332 12.3346L7.15849 12.0156C7.32684 6.82449 11.588 2.66797 16.82 2.66797ZM19.64 24.6653H13.9987L14.4366 26.5576C14.5308 26.966 14.8675 27.2672 15.2734 27.3233L15.411 27.3328H18.2294C18.6484 27.3328 19.0175 27.0725 19.1635 26.6898L19.2037 26.5579L19.64 24.6653ZM16.82 4.66797C12.6843 4.66797 9.3134 7.94265 9.15886 12.0406L9.15332 12.3346L9.16227 12.704C9.2638 14.7885 10.2296 16.7295 12.1035 18.5596C12.4557 18.9036 12.7169 19.328 12.8656 19.7946L12.9305 20.0313L13.5373 22.6653H20.1013L20.7118 20.0304C20.8225 19.5513 21.049 19.1079 21.3699 18.7385L21.5381 18.5601C23.4109 16.73 24.3762 14.7888 24.4777 12.704L24.4866 12.3346L24.4811 12.0406C24.3265 7.94266 20.9557 4.66797 16.82 4.66797Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/Idea.8c1b87d542b4e38f38e8dd73a4fd7206.svg";
export { ForwardRef as ReactComponent };